// Tresc komorek zakladki "Wybor pozycji" (jak scalable-td w listach standardowych):
// line - znakow w 1 linii, wrap - zawijanie na spacji, max - limit calosci ("…" + tooltip).
// Kolumny spoza mapy sie nie zawijaja. Zakladka "Analiza" i szablon analizy (GroupedAndSortedDocuments)
// korzystaja tylko z max - kolumny z mapy zawijaja sie tam do szerokosci pozostalej po reszcie.
export const ANALYZE_COLUMN_TEXT_RULES = {
    document_number:     {line: 30, wrap: false, max: 55},
    contractor_id:       {line: 40, wrap: true,  max: 66},
    item_name:           {line: 60, wrap: true,  max: 106},
    description:         {line: 60, wrap: true,  max: 106},
    document_type:       {line: 25, wrap: true,  max: null},
    contractor_state_id: {line: 40, wrap: true,  max: 66},
    margin_type_id:      {line: 40, wrap: true,  max: 66},
    remarks:             {line: 60, wrap: true,  max: 106},
    contractor_city:     {line: 25, wrap: true,  max: 41},
    contractor_country:  {line: 25, wrap: true,  max: 41},
    contract_number:     {line: 30, wrap: false, max: 55},
    terms_of_delivery:   {line: 40, wrap: true,  max: 66},
    cn:                  {line: 30, wrap: false, max: 55},
    pkob:                {line: 30, wrap: false, max: 55},
};

export const getTransForAnalyze = {
    methods: {
        getTransColumn(column) {
            let value = ''
            if(column == 'unit_price_calculation'){
                value = this.__('price_type')
            }
            if(column == "contractor_id"){
                value = this.__('contractor')
            }
            if(column == 'description'){
                value = this.__('goods_or_service_description')
            }
            if(column == 'item_vat_rate'){
                value =  this.__('item_vat_rate_value')
            }
            if(column == 'item_vat_refund'){
                value =  this.__('part_vat_refunded_from_us')
            }
            if(column == 'vat_settlement_id'){
                value = this.__('way_of_vat_settlement')
            }
            if(column == 'net_in_base_currency'){
                value = this.__('net_in_base_currency_in') + this.userInfo.default_currency.toUpperCase()
            }
            if(value == ''){
                return this.__(column).charAt(0).toUpperCase() + this.__(column).slice(1);
            }
            else{
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        isMoneyFormat(column){
            return ['item_quantity', 'item_unit_price', 'item_net_amount', 'item_gross_amount', 'price_before_discount', 'item_vat_amount', 'item_vat_refund_amount', 'item_margin','net_in_base_currency', 'discount', 'item_vat_rate', 'item_margin_vat_amount', 'excise_tax_amount'].includes(column);

        }

    },
    computed:{
        userInfo: function () {
            return this.$store.getters.getUserInfo
        },
    },

};
